import {AutogenLayoutTruckSearch} from "./autogen/AutogenLayoutTruckSearch";
import {DataSourceExecutionEvent, DataSourceMode} from "@mcleod/components";

export class TruckSearch extends AutogenLayoutTruckSearch{

    sourceLoadBoardServiceBeforeExecution(event : DataSourceExecutionEvent) {
        event.filter.posting_format = "T";
        event.filter.service_type = "%T%";
    }

    onLoad() {
        this.mainDataSource.doBeforeDataSourcePost = async () => {
            if(this.mainDataSource.mode === DataSourceMode.ADD) {
                this.mainDataSource.activeRow.set("posting_format", "T");
                this.mainDataSource.activeRow.set("service_type", "T");

            }
            return true;
        }
    }
}
